module.exports = __webpack_public_path__ + "assets/img/detail17.681d4b40.png";